import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const HubSpotLiveChat = () => {

  const setupHubSpotScript = () => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', 'hs-script-loader');
    script.setAttribute('async', 'true');
    script.setAttribute('defer', 'true');
    script.setAttribute('src', '//js-eu1.hs-scripts.com/143558232.js');
    document.body.appendChild(script);
  };

  useEffect(() => {
    setupHubSpotScript();
  }, []);

  return <Outlet />;
};

export default HubSpotLiveChat;